'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reauthService;

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _isServer = require('../utils/isServer');

var _isServer2 = _interopRequireDefault(_isServer);

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reauthService(config, apiContext) {
  var proxyReauthEndpoint = config.domains.local + '/auth/reauth/';
  var reauthEndpoint = config.domains.opml + '/oauth/access_token';

  var auth = void 0;

  if (config.auth) {
    auth = {
      username: config.auth.clientId,
      password: config.auth.clientSecret
    };
  }

  function proxyReauth() {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: proxyReauthEndpoint,
      isAjax: true,
      disableRetry: true
    }, apiContext);
  }

  function reauth() {
    if (!(0, _isServer2.default)()) {
      return proxyReauth();
    }

    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: reauthEndpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      auth: auth,
      data: _qs2.default.stringify({
        refreshToken: apiContext.getTokens().refreshToken
      }),
      disableRetry: true
    }, apiContext);
  }

  return reauth;
}
//# sourceMappingURL=reauth.js.map